import { Button } from '../../design'
import { formatTimeOfDay } from '../../lib/time'
import { STATUS_COPY, STATUS_DETAIL_COPY } from './copy'
import type { StatusEntry } from './store'

const OutageMark = () => (
  <svg
    className="outage-mark"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 4.5L21 20H3z" />
    <path d="M12 10.5v4" />
    <path d="M12 17.2h.01" />
  </svg>
)

const OutageFact = ({ term, value }: { term: string; value: string }) => (
  <div className="outage-fact">
    <dt className="outage-fact-term">{term}</dt>
    <dd className="outage-fact-value num">{value}</dd>
  </div>
)

export const OutageScreen = ({ entry, lastSyncedAt }: { entry: StatusEntry; lastSyncedAt: string | null }) => (
  <div className="outage" role="alert">
    <div className="outage-band hatch" aria-hidden="true" />
    <div className="outage-sheet">
      <OutageMark />
      <h1 className="outage-title">{STATUS_COPY.database_outage.title}</h1>
      <p className="outage-lede">{STATUS_DETAIL_COPY.outageBody}</p>
      <dl className="outage-facts">
        <OutageFact
          term={STATUS_DETAIL_COPY.lastSynced}
          value={lastSyncedAt === null ? STATUS_DETAIL_COPY.never : formatTimeOfDay(new Date(lastSyncedAt))}
        />
        <OutageFact term={STATUS_DETAIL_COPY.since} value={formatTimeOfDay(new Date(entry.since))} />
      </dl>
      <Button variant="primary" size="large" onClick={() => window.location.reload()}>
        {STATUS_DETAIL_COPY.reload}
      </Button>
    </div>
  </div>
)
